/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_ProductInputs */

const en_svtag_product = /** @type {(inputs: Svtag_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PRODUCT`)
};

const ar_svtag_product = /** @type {(inputs: Svtag_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#منتج`)
};

const bn_svtag_product = /** @type {(inputs: Svtag_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PRODUCT`)
};

const de_svtag_product = /** @type {(inputs: Svtag_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PRODUCT`)
};

const es_svtag_product = /** @type {(inputs: Svtag_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PRODUCT`)
};

const fr_svtag_product = /** @type {(inputs: Svtag_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PRODUCT`)
};

const pt_svtag_product = /** @type {(inputs: Svtag_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PRODUCT`)
};

const zh_svtag_product = /** @type {(inputs: Svtag_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PRODUCT`)
};

const tr_svtag_product = /** @type {(inputs: Svtag_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PRODUCT`)
};

const ru_svtag_product = /** @type {(inputs: Svtag_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PRODUCT`)
};

const pl_svtag_product = /** @type {(inputs: Svtag_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#PRODUCT`)
};

/**
* | output |
* | --- |
* | "#PRODUCT" |
*
* @param {Svtag_ProductInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_product = /** @type {((inputs?: Svtag_ProductInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_ProductInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_product(inputs)
	if (locale === "bn") return bn_svtag_product(inputs)
	if (locale === "de") return de_svtag_product(inputs)
	if (locale === "es") return es_svtag_product(inputs)
	if (locale === "fr") return fr_svtag_product(inputs)
	if (locale === "pt") return pt_svtag_product(inputs)
	if (locale === "zh") return zh_svtag_product(inputs)
	if (locale === "tr") return tr_svtag_product(inputs)
	if (locale === "ru") return ru_svtag_product(inputs)
	if (locale === "pl") return pl_svtag_product(inputs)
	return en_svtag_product(inputs)
});